import { render, staticRenderFns } from "./ClubSwitchFilters.vue?vue&type=template&id=aa124380&"
import script from "./ClubSwitchFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClubSwitchFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa124380')) {
      api.createRecord('aa124380', component.options)
    } else {
      api.reload('aa124380', component.options)
    }
    module.hot.accept("./ClubSwitchFilters.vue?vue&type=template&id=aa124380&", function () {
      api.rerender('aa124380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/ClubSwitchFilters/ClubSwitchFilters.vue"
export default component.exports